import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetDateTimeQuery } from "shared/services/common/service-date-time";
import { setCommonDateTime } from "shared/stores/reducers/commonSlice";

export function ServerClock() {
  const dispatch = useDispatch();
  const { data, refetch } = useGetDateTimeQuery();
  const [localTime, setLocalTime] = useState(null);

  useEffect(() => {
    if (data?.day) {
      setLocalTime(dayjs(data.day)); // ✅ always store as dayjs object
      dispatch(setCommonDateTime(data?.dayjsFormat));
    }
  }, [data]);

  // 🔄 Local ticking every second
  useEffect(() => {
    if (!localTime) return;
    const timer = setInterval(() => {
      setLocalTime(prev => dayjs(prev).add(1, "second"));
      // ✅ wrap prev in dayjs() to ensure it's always a dayjs object
    }, 1000);
    return () => clearInterval(timer);
  }, [localTime]);

  // useEffect(() => {
  //   const handleClick = e => {
  //     console.log("Clicked element:", e.target.tagName);
  //     if (e.target.tagName === "BUTTON") {
  //       console.log("A button was clicked!");
  //       refetch();
  //     }
  //   };
  //   window.addEventListener("click", handleClick);
  //   return () => {
  //     window.removeEventListener("click", handleClick);
  //   };
  // }, []);

  return localTime && <div style={{ margin: "auto 15px" }}>{localTime.format("DD MMM YYYY HH:mm")}</div>;
  //   return localTime && <Clock date={localTime} format="DD/MM/YYYY HH:mm:ss" ticking={true} />;
}
